<script>
import store from '@state/store'
import { authComputed } from '@state/helpers'

export default {
  props: {
    challengeId: { type: Number, required: true },
    messages: { type: Array, required: true },
  },
  data() {
    return {
      newComment: '',
      isPosting: false,
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    isRightSide(item) {
      return item.user && item.user.id && item.user.id === this.currentUserId
    },
    postComment() {
      if (this.isPosting || !this.newComment) {
        return
      }
      this.isPosting = true
      store
        .dispatch('challenges/newMessage', {
          message: this.newComment,
          challenge_id: this.challengeId,
          user_id: this.currentUserId,
        })
        .then(() => {
          this.newComment = ''
          store.dispatch('auth/validate')
        })
        .catch(() => {})
        .finally(() => {
          this.isPosting = false
        })
    },
  },
}
</script>

<template>
  <div class="bg-gray-light p-4">
    <div :style="{ minHeight: `439px` }">
      <div
        v-for="item in messages"
        :key="item.id"
        class="flex flex-col pb-8 px-4"
        :class="isRightSide(item) ? ' items-end' : ''"
      >
        <div
          class="bg-white rounded-2xl relative pl-5 pr-3 py-3 w-4/5"
          :class="isRightSide(item) ? 'rounded-br-none' : 'rounded-bl-none'"
        >
          <div
            class="absolute w-8 h-8 overflow-hidden bottom-0 -mb-4"
            :class="isRightSide(item) ? 'right-0 -mr-4' : 'left-0 -ml-4'"
          >
            <img class="w-8 rounded-full" :src="item.user.image_url" />
          </div>
          <div>{{ item.message }}</div>
        </div>
        <div class="text-sm text-blue-darker px-6 mt-1">
          {{ item.user.name }}
        </div>
      </div>
    </div>

    <div class="comment-form bg-white">
      <textarea v-model="newComment" placeholder="Post a Comment"> </textarea>
      <button
        class="button primary-button leading-relax text-sml rounded-small-button px-3"
        :disabled="isPosting"
        @click="postComment"
      >
        {{ isPosting ? 'Commenting' : 'Comment' }}
      </button>
    </div>
  </div>
</template>
